module.exports = __webpack_public_path__ + "static/home1-products-by-category-63d6d41219df1dced12840511e9ec0dc.jpg";